import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "../CookieConsent";

export const Layout = ({ children }) => (
  <div className="App min-h-screen bg-background pm-noise">
    <Header />
    <main>{children}</main>
    <Footer />
    <CookieConsent />
  </div>
);
